<template>
    <div class='header'>
        <header>
            <div class="container">
                <div class="d-flex justify-content-between">
                    <ul class="icon-left d-flex list-unstyled mb-0 flex_1">
                        <li>
                            <div class="left-tow">
                                <span class="p-r">
                                    <router-link to="/check_order" title="訂單查詢" alt="訂單查詢">
                                        <button class="btn b-r  d-flex align-items-center justify-content-center"
                                            type="button" aria-label="訂單查詢">
                                            <i class="icon-new_ordersearch md-16"></i>
                                        </button>
                                    </router-link>
                                    <div class="btn_tips p-a mb-0">
                                        <span class="top_triangle d-block mx-auto"></span>
                                        <h6 class="d-flex mb-0">訂單查詢</h6>
                                    </div>
                                </span>
                                <span class="p-r">
                                    <router-link to="/shopping_instructions" title="購物說明" alt="購物說明">
                                        <button
                                            class="btn b-r  d-flex align-items-center justify-content-center js_hover_effect"
                                            type="button" aria-label="購物說明">
                                            <i class="icon-new_info md-16"></i>
                                        </button>
                                    </router-link>
                                    <div class="btn_tips p-a mb-0">
                                        <span class="top_triangle d-block mx-auto"></span>
                                        <h6 class="d-flex mb-0">購物說明</h6>
                                    </div>
                                </span>
                            </div>
                        </li>
                    </ul>
                    <div class="icon-right">
                        <ul class="social_list d-flex list-unstyled mb-0" v-if="website.company_info">
                            <li><span v-for="item in website.company_info">
                                    <a class="d-block" v-if="item.key == 'FB_Link'" :href="item.value"
                                        target="_blank"><img class="mw-100" src="@/assets/svg/img_facebook.svg"
                                            width="30" height="30" alt="facebook"></a>
                                </span></li>
                            <li><span v-for="item in website.company_info">
                                    <a class="d-block" v-if="item.key == 'Line_Link'" :href="item.value"
                                        target="_blank"><img class="mw-100" src="@/assets/svg/img_line.svg" width="30"
                                            height="30" alt="line"></a>
                                </span></li>
                            <li>
                                <a class="d-block" href="/" alt="商城首页" title="商城首页">
                                    <svg data-name=" 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"
                                        style="width: 30px;">

                                        <circle class="cls-1" cx="36" cy="36" r="36"></circle>
                                        <path class="cls-2"
                                            d="M41.62,33.6a3.3,3.3,0,0,1-3.25-2.36V18h4.45l2.06,6.44v5.9a3.27,3.27,0,0,1-3.26,3.26Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M30.38,33.6a3.27,3.27,0,0,1-3.26-3.26v-5.9L29.18,18h4.45V30.34a3.26,3.26,0,0,1-3.25,3.26Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M19.14,33.6a3.27,3.27,0,0,1-3.26-3.26V24.66L19.43,18h4.78l-1.82,5.7v6.64a3.26,3.26,0,0,1-3.25,3.26Z">
                                        </path>
                                        <path class="cls-2" d="M32.41,45.91h7.31V54H32.41Z"></path>
                                        <path class="cls-2"
                                            d="M44.45,54V43.54a2.37,2.37,0,0,0-2.36-2.37H30a2.37,2.37,0,0,0-2.37,2.37V54H21.94a1.64,1.64,0,0,1-1.64-1.65V38.24A8,8,0,0,0,24.76,36h0a8,8,0,0,0,11.18.06h0s.09.08.13.13a8.27,8.27,0,0,0,5.55,2.13h0A7.86,7.86,0,0,0,47.24,36h0a8,8,0,0,0,4.42,2.23h0v14.1A1.65,1.65,0,0,1,50.06,54H44.45Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M52.86,33.6a3.26,3.26,0,0,1-3.25-3.26V23.7L47.79,18H52.6c1.68,3,3.07,5.61,3.52,6.53v5.81a3.27,3.27,0,0,1-3.26,3.26Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
        <div class="mobile">
            <ul class="mobile-menu d-flexs  list-unstyled mb-0 " id="mobile-menu">
                <li data-bs-toggle="offcanvas" data-bs-target="#mune" aria-controls="mune" @click="none_serch">
                    <div class="list d-flexs align-items-center justify-content-center" data-type="menu">
                        <a class=" btn  d-flexs flex-column align-items-center border-0" href="javascript:;">
                            <i class="icon-new_menu md-20"></i>
                            <!-- <h6 class="mb-0">選單</h6> -->
                        </a>
                    </div>
                </li>
                <li class="" @click="none_serch">
                    <div class="list  d-flexs align-items-center justify-content-center" data-type="order">
                        <router-link to="/check_order" class=" btn  d-flexs flex-column align-items-center border-0 ">
                            <i class="icon-new_ordersearch md-20"></i>
                            <!-- <h6 class="mb-0">查訂單</h6> -->
                        </router-link>
                    </div>
                </li>
                <li class="" @click="none_serch">
                    <div class="list d-flexs  align-items-center justify-content-center" data-type="member">
                        <a class=" btn  d-flexs flex-column align-items-center border-0" href="/"
                            style="color: #fff; padding: 0px ; height: 50px;">

                            <ImageLoader :key="index" :imageSrc="website.logo_url" :maxHeight="'50px'" altText="logo"
                                :mywidth="'50px'" :myheght="'50px'" />

                        </a>
                    </div>
                </li>
                <li class="serch" @click.stop="serch">
                    <div class="list  d-flexs align-items-center justify-content-center" data-type="search">
                        <span class="mobile_seo btn   d-flexs flex-column align-items-center border-0" id="affter_icon">
                            <i class="icon-new_search md-20"></i>
                            <!-- <h6 class="mb-0" id="serch_icon">搜尋</h6> -->
                        </span>
                        <div id="serch" class="p-a p-10 d-none" @click.stop>
                            <div class="form_group mb-0 ">

                                <input @click.stop="" v-model="seachcart" @keyup.enter="goseachcart()"
                                    id="form_search_mobile" name="keyword" class="" placeholder="商品搜尋" type="text">

                            </div>
                            <div class="form_group mb-0 " style=" margin-top: 10px;">
                                <ul class="search_ul">
                                    <li v-for="item in gethostSearch">
                                        <a href="javascript:;" @click="goclickseachcart($event)">{{ item.name }}</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div id="serch_bg" class="back d-none" @click.stop="none_serch"></div>
                    </div>
                </li>
                <li class="el_nav_fn" data-bs-toggle="offcanvas" data-bs-target="#cart" aria-controls="cart"
                    @click="none_serch">
                    <div class="list   d-flexs align-items-center justify-content-center" data-type="cart">
                        <span class="mobile_seo  btn   d-flexs flex-column align-items-center border-0">
                            <span class="cart d-flexs justify-content-center">
                                <i class="icon-new_cart md-24"></i>
                                <small class=" d-block" style="background-color: #F17C67;">
                                    <span class="p-r ">{{ number }}</span></small>
                            </span>
                            <!-- <h6 class="mb-0 cart-h6">購物車</h6> -->
                        </span>
                    </div>
                </li>
            </ul>
            <ul class="mobile-icon list-unstyled mb-0 d-flexs " id="mobile-icon">
                <li>
                </li>
                <li class="cart" data-bs-toggle="offcanvas" data-bs-target="#cart" aria-controls="cart">
                    <a href="javascript:;">
                        <span class="cart-icon justify-content-center">
                            <i class="icon-new_cart md-24"></i>
                        </span>
                        <small class=" d-block" style="background-color: #F17C67;">
                            <span class="p-r">{{ number }}</span></small>
                    </a>
                </li>
            </ul>

        </div>
        <div class="bg">
            <div class="cart-serch">
                <ul class="list-unstyled">
                    <li data-bs-toggle="offcanvas" data-bs-target="#cart" aria-controls="cart">
                        <div class="cart p-r">
                            <span class="cart-icon justify-content-center">
                                <i class="icon-new_cart md-24"></i>
                            </span>
                            <small class=" d-block" style="background-color: #F17C67;">
                                <span class="p-r">{{ number }}</span></small>
                        </div>
                    </li>
                    <li>
                        <div class="serch p-a">
                            <input @keyup.enter="goseachcart()" v-model="seachcart" type="text p-a" placeholder="商品搜尋">
                            <label class="serch-icon p-a">
                                <i class="icon-new_search md-24" style="color: #6E7C7C;"></i>
                            </label>
                            <ul class="hostseach">
                                <li v-for="item in gethostSearch" @click.stop="goclickseachcart($event)">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>

            </div>
            <span class="s-bg filter_0 p-a"></span>
            <div class="container">
                <a class="img" href="/" style="display: flex;"
                    v-if="getfront[2]?.img !== '' && getfront[2]?.img !== null">
                    <ImageLoader class="mw-100" style="width: 100%;" :imageSrc="getfront[2]?.img" :key="index"
                        :altText="getfront[2]?.alt" />
                </a>

                <div class="navbar-collapse container" id="navbar-collapse">
                    <div class="wrap">
                        <ul class="navbar-nav justify-content-center d-flex flex-wrap list-unstyled mb-0 "
                            id="navbar-nav">
                            <li class="nav-item p-r" v-for="item in cate" :key="item.cate_name"
                                @click="is_active($event); gocategory_list(item)">
                                <a href="javascript:;" class="nav-link">
                                    <span>{{ item.cate_name }}</span>
                                </a>
                            </li>
                            <li class="nav-item p-r" v-for="item in getnav" :key="item.name"
                                @click="is_active($event); gonav(item)">
                                <a href="javascript:;" class="nav-link">
                                    <span>{{ item.name }} </span>
                                </a>
                            </li>
                            <li class="nav-item p-r" v-if="isarticle" @click="is_active($event); goarticle()">
                                <a href="javascript:;" class="nav-link">
                                    <span>文章專欄</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加入购物车 -->
        <div class="offcanvas offcanvas-end" style="max-width: 300px;border: none;" tabindex="-1" id="cart"
            aria-labelledby="offcanvasRightLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasRightLabel">我的購物車</h5>
                <button data-bs-dismiss="offcanvas" class="cart_btn_close"> <span
                        class="collapse-text"></span>✕</button>
            </div>
            <div class="offcanvas-body">
                <div v-if="number != 0" class="cart">
                    <div v-if="true" class="hascart">
                        <ul class="cart-ul list-unstyled mb-0">
                            <li class="cart-li" v-for="item, index in cart_list_item">
                                <div class="list d-grid">
                                    <div class="img">
                                        <img :src="item.display_img_small" alt="">
                                    </div>
                                    <div class="info d-grid">
                                        <div class="title">
                                            <span class="text_overflow"><a href="javascript:;">{{ item.form_name
                                                    }}</a></span>
                                            <div v-if="item.sub.length !== 0">
                                                <span class="guige" v-for="itemsub in item.sub">
                                                    <span v-if="itemsub.sub_type == 'SFREE'" style="color: #dc3545;">贈品-{{
                            itemsub.form_name }}*{{ itemsub.num }}</span>
                                                    <span v-else>{{ itemsub.form_name }}*{{ itemsub.num }}</span>
                                                </span>
                                            </div>
                                            <span v-else class="guige">單一規格</span>

                                        </div>
                                        <div class="selectquantity d-flex justify-content-between align-items-center">
                                            <div class="form_label pb-0" for=""></div>
                                            <div class="selectquantity_select">
                                                <div class=" number d-flex   justify-content-between ">
                                                    <button type="button" class="btn iconfont"
                                                        @click="reduce(item, index)">&#xeaf5;
                                                    </button>
                                                    <input type="text" name="quantity"
                                                        @change="changebalue(item, index)" v-model="item.num"
                                                        class="border-0 text-center w-100   p-0" data-max="1"
                                                        data-min="1" oninput="value=value.replace(/\D/g,'')">
                                                    <button type="button" class="btn iconfont"
                                                        @click="add(item, index)">&#xeaf3;
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="price">${{ item.total }}</div>
                                        <div class="icon" @click="del(item)"><i class="icon-new_trash"></i></div>
                                    </div>
                                </div>
                                <!-- 子商品模态框 -->
                                <div class="modal fade child" :id="'h' + item.item_id" tabindex="-1"
                                    aria-labelledby="exampleModalLabel2" aria-hidden="true">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h1 class="modal-title fs-5" id="exampleModalLabel"
                                                    style="color: #333333;">
                                                    {{ item.form_name }}
                                                </h1>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                    aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                <!-- {{ child_list }} -->
                                                <h2 class="title" style="color: #333333;">请选择{{ child_num }}件商品 </h2>
                                                <div v-for="item, index in child_list">
                                                    <div class="form_name"> *{{ item.form_name }}</div>
                                                    <div class="number">
                                                        <button type="button" class="btn iconfont"
                                                            @click="decrement(index)">-
                                                        </button>
                                                        <input type="number" name="quantity"
                                                            @input="validateInput(index)" v-model="item.display_num"
                                                            class=" text-center w-100   p-0" data-max="1" data-min="1">
                                                        <button type="button" class="btn iconfont"
                                                            @click="increment(index)">+
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                                <button type="button" class="btn btn-primary"
                                                    @click="opmodef(false)">確認</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="bill" @click="gocart()" data-bs-dismiss="offcanvas">前往結帳</div>
                    </div>
                    <div v-else class="nocart d-grid">

                        <i class="icon-new_nocart"></i>
                        <span>購物車內無任何商品！</span>
                    </div>
                </div>
                <div style="padding: 10px;" v-else>
                    <div
                        style="border: 1px solid #d9d9d9;font-size: 60px; color: #d9d9d9; display: flex;flex-direction: column;align-items: center; padding: 10px;">
                        <i class="icon-new_nocart"></i>
                        <span style="font-size: 14px;">購物車內無任何商品！</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 菜单 -->
        <div class="offcanvas offcanvas-start" style="max-width: 300px;border: none; " tabindex="1" id="mune"
            aria-labelledby="offcanvasExampleLabel">
            <div class="offcanvas-body">
                <div class="menu">
                    <div class="header">
                        <div class="logo">
                            <a href="/">
                                <img :src="website.logo_url" alt="">
                            </a>
                            <h3 class="mb-0 text">{{ seo.og_title }}</h3>
                        </div>
                        <div class="icon">
                            <ul class="social_list d-flex list-unstyled mb-0" v-if="website.company_info">
                                <li><span v-for="item in website.company_info">
                                        <a class="d-block" v-if="item.key == 'FB_Link'" :href="item.value"
                                            target="_blank"><img class="mw-100" src="@/assets/svg/img_facebook.svg"
                                                width="30" height="30" alt="facebook"></a>
                                    </span></li>
                                <li><span v-for="item in website.company_info">
                                        <a class="d-block" v-if="item.key == 'Line_Link'" :href="item.value"
                                            target="_blank"><img class="mw-100" src="@/assets/svg/img_line.svg"
                                                width="30" height="30" alt="line"></a>
                                    </span></li>
                                <li>
                                    <a class="d-block" href="/" alt="商城首页" title="商城首页">
                                        <svg data-name=" 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"
                                            style="width: 30px;">

                                            <circle class="cls-1" cx="36" cy="36" r="36"></circle>
                                            <path class="cls-2"
                                                d="M41.62,33.6a3.3,3.3,0,0,1-3.25-2.36V18h4.45l2.06,6.44v5.9a3.27,3.27,0,0,1-3.26,3.26Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M30.38,33.6a3.27,3.27,0,0,1-3.26-3.26v-5.9L29.18,18h4.45V30.34a3.26,3.26,0,0,1-3.25,3.26Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M19.14,33.6a3.27,3.27,0,0,1-3.26-3.26V24.66L19.43,18h4.78l-1.82,5.7v6.64a3.26,3.26,0,0,1-3.25,3.26Z">
                                            </path>
                                            <path class="cls-2" d="M32.41,45.91h7.31V54H32.41Z"></path>
                                            <path class="cls-2"
                                                d="M44.45,54V43.54a2.37,2.37,0,0,0-2.36-2.37H30a2.37,2.37,0,0,0-2.37,2.37V54H21.94a1.64,1.64,0,0,1-1.64-1.65V38.24A8,8,0,0,0,24.76,36h0a8,8,0,0,0,11.18.06h0s.09.08.13.13a8.27,8.27,0,0,0,5.55,2.13h0A7.86,7.86,0,0,0,47.24,36h0a8,8,0,0,0,4.42,2.23h0v14.1A1.65,1.65,0,0,1,50.06,54H44.45Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M52.86,33.6a3.26,3.26,0,0,1-3.25-3.26V23.7L47.79,18H52.6c1.68,3,3.07,5.61,3.52,6.53v5.81a3.27,3.27,0,0,1-3.26,3.26Z">
                                            </path>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="list">
                        <ul class="list-ul list-unstyled mb-0">
                            <li class="list-li" data-bs-dismiss="offcanvas">
                                <router-link to="/">
                                    首頁
                                </router-link>
                            </li>
                            <li class="subclassification">分類</li>
                            <li class="list-li">
                                <router-link to="/all_category">所有商品</router-link>
                            </li>
                            <li data-bs-dismiss="offcanvas" class="list-li" v-for="item in cate" :key="item.cate_name"
                                @click="is_active($event); gocategory_list(item)">
                                <!-- <input id="mobileinp" class="inp" type="checkbox"> -->
                                <a href="javascript:;" class="">
                                    <span>{{ item.cate_name }}</span>
                                </a>
                            </li>
                            <li class="subclassification">商店資訊</li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <router-link to="/about">關於</router-link>
                            </li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <router-link to="/contact_us">聯絡我們</router-link>
                            </li>
                            <li class="subclassification">精選文章推薦</li>
                            <li class="list-li" @click=" goarticle()" data-bs-dismiss="offcanvas"
                                style="cursor: pointer;">
                                <a href="javascript:; ">
                                    文章專欄
                                </a>
                            </li>
                            <li class="list-li" v-for="item in getnav" :key="item.name" @click=" gonav(item)"
                                data-bs-dismiss="offcanvas" style="cursor: pointer;">
                                <a href="javascript:; ">
                                    {{ item.name }}
                                </a>

                            </li>
                            <li class="subclassification">訂單</li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <router-link to="/check_order">訂單查詢</router-link>
                            </li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <a href="javascript:;" @click="goshopping_instructions('訂單相關說明')">訂單相關說明</a>
                            </li>
                            <li class="subclassification">其他</li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <a href="javascript:;" @click="goshopping_instructions('付款方式說明')">付款方式說明</a>
                            </li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <a href="javascript:;" @click="goshopping_instructions('寄送方式說明')">寄送方式說明</a>
                            </li>
                            <li data-bs-dismiss="offcanvas" class="list-li">
                                <a href="javascript:;" @click="goshopping_instructions('售後服務說明')">售後服務說明</a>
                            </li>
                            <li class="list-li">
                                <router-link to="/announcement">防詐騙公告</router-link>
                            </li>


                        </ul>
                        <div class="footer">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import FacebookEventApi from '@/js/FacebookEventApi'
import ImageLoader from '@/components/Image_loading.vue'
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
export default {
    components: {
        ImageLoader
    },
    data() {
        return {
            serchshow: false,
            nav: [],
            seachcart: '',
            isfirst: true,
            active: '',
            ipnum: [
                { num: '2', }
            ],
            //child
            child_list: [],//子商品内容
            child_num: '',//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量
            selectname: '',//商品id

            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量


        };
    },
    computed: {
        ...mapState('header', ['cate', 'website', 'getnav', 'getfb', 'gethostSearch', 'getfront', 'seo', 'isarticle']),
        ...mapState('cart', ['number', 'cart_list_item']),
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        },
    },
    watch: {},
    methods: {
        opmodef(val) {
            // this.item=this.$store.getters["commodity/details"];
            // this.clickvalue();

            let numbers = 0
            if (val) {
                this.parm = this.child_list.map(item => {
                    numbers += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num * this.child_number
                    };
                });
            } else {
                this.parm = this.child_list.map(item => {
                    numbers += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num
                    };
                });
            }
            this.free_parm = this.free.map(item => {
                // number_free += item.display_num
                return {
                    item: item.isubid,
                    num: this.free_num * this.child_number
                };
            });
            this.parm = this.parm.concat(this.free_parm);
            this.free_parm = [];
            if (numbers == this.child_num) {
                this.$store.dispatch('cart/add', {
                    action: 'UPDATE',
                    itemid: this.selectname,
                    number: this.child_number,
                    type: 'NOR',
                    param: this.parm,
                }).then((e) => {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    if (e.result) {
                        Toast.fire({
                            icon: 'success',
                            title: '成功加入購物車'
                        })
                        this.subtotal = 0
                        this.ipnum = this.$store.getters['cart/cart_list_item'];
                        this.ipnum.forEach(element => {
                            this.subtotal += element.price.replace(/,/g, "") * element.num;
                        });
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: `${e.message}`
                        })
                    }

                });

                const myModal = this.$bootstrap.Modal.getInstance(document.getElementById('h' + this.selectname));
                myModal.hide();
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'warning',
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`
                })
            }
        },
        // 手机模式搜索商品框
        serch() {
            if (this.serchshow) {
                document.documentElement.style.overflowY = 'scroll';
                this.serchshow = !this.serchshow;
                $('#serch').addClass('d-none');
                $('#serch_bg').addClass('d-none');
                $("#affter_icon").removeClass('affter_icon');
            } else {
                document.documentElement.style.overflowY = 'hidden';
                this.serchshow = !this.serchshow;
                $('#serch').removeClass('d-none');
                $('#serch_bg').removeClass('d-none');
                $("#affter_icon").addClass('affter_icon');
            }
        },
        none_serch() {
            document.documentElement.style.overflowY = 'scroll';
            this.serchshow = false;
            $('#serch').addClass('d-none');
            $('#serch_bg').addClass('d-none');
            $("#affter_icon").removeClass('affter_icon');
        },
        //搜索商品
        goseachcart() {
            this.$store.dispatch('commodity/getsearch', this.seachcart);
            document.documentElement.style.overflowY = 'scroll';
            this.serchshow = false;
            $('#serch').addClass('d-none');
            $('#serch_bg').addClass('d-none');
            $("#affter_icon").removeClass('affter_icon');


            this.$router.push({
                path: `/search/${this.seachcart}`
            }).catch(err => { })
            this.seachcart = '';
        },
        //点击前往搜索的商品
        goclickseachcart(event) {
            this.$store.dispatch('commodity/getsearch', event.target.innerText);
            document.documentElement.style.overflowY = 'scroll';
            this.serchshow = false;
            $('#serch').addClass('d-none');
            $('#serch_bg').addClass('d-none');
            $("#affter_icon").removeClass('affter_icon');
            this.$router.push({
                path: `/search/${event.target.innerText}`
            }).catch(err => { })
        },
        // 选中高亮
        is_active(e) {

            $('#navbar-nav')[0].childNodes.forEach(element => {
                $(element).removeClass('active')
            });
            $(e.currentTarget).addClass('active');

        },
        gonav(e) {
            this.$router.push({
                path: `/nav/${e.name}`,
            }).catch(err => {

            })
            this.$store.commit('header/SET_NAVCONTENT', e)
        },
        //前往文章专栏
        goarticle(e) {
            this.$router.push({
                path: `/article`,
            }).catch(err => {

            })
        },
        // 前往商品列表
        gocategory_list(e) {
            if (!this.isfirst) {
                this.$store.dispatch('commodity/getclassification', e.cid).then(response => {
                    this.$router.push({
                        path: `/category_list/${e.cid}/${e.cate_name}`,
                    }).catch(err => { })

                });
            } else {
                this.$router.push({
                    path: `/category_list/${e.cid}/${e.cate_name}`,
                }).catch(err => { })
                this.isfirst = false;
            }

        },
        gocart() {
            this.$router.push({
                path: `/cart`
            }).catch(err => { })
            $('#navbar-nav')[0].childNodes.forEach(element => {
                $(element).removeClass('active')
            });
        },
        // 回到主页
        goindex() {
            this.$router.push({
                path: `/`
            }).catch(err => { })
            $('#navbar-nav')[0].childNodes.forEach(element => {
                $(element).removeClass('active')
            });

        },
        // 数量减
        reduce(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            if (num > 1) {
                num = --e.num;
                this.child_number = num;
                this.parm = []
                if (e.sub.length !== 0) {
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num * this.child_number || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            this.free_parm = this.free.map(item => {
                                return {
                                    item: item.isubid,
                                    num: this.free_num * num
                                };
                            });
                            if (response.data.sub.length === 1) {
                                this.child_num = response.data.num || 0;
                                this.child_list[0].display_num = response.data.num
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                this.opmodef(true);
                            } else if (response.data.num !== 0) {
                                const myModal = new this.$bootstrap.Modal(document.getElementById('h' + this.selectname), {
                                    keyboard: false
                                });
                                myModal.show();
                                let backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.style.display = 'none';
                                }

                            } else if (response.data.sub.length === 0) {
                                this.opmodef(true);
                            }
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'error',
                                title: `${response.message}`
                            })
                        }
                        // $('#myModal').modal('show');
                        // console.log($('#myModal'));
                        // console.log($('#myModal').modal());
                    });
                } else {
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                    });
                }
            }
        },
        // 数量加
        add(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            if (num < 99) {
                num = ++e.num;
                this.child_number = num;
                this.parm = []
                if (e.sub.length !== 0) {
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num * this.child_number || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            this.free_parm = this.free.map(item => {
                                return {
                                    item: item.isubid,
                                    num: this.free_num * num
                                };
                            });
                            if (response.data.sub.length === 1) {
                                this.child_num = response.data.num || 0;
                                this.child_list[0].display_num = response.data.num

                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                this.opmodef(true);
                            } else if (response.data.num !== 0) {
                                const myModal = new this.$bootstrap.Modal(document.getElementById('h' + this.selectname), {
                                    keyboard: false
                                });
                                myModal.show();
                                let backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.style.display = 'none';
                                }

                            } else if (response.data.sub.length === 0) {
                                this.opmodef(true);
                            }
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'error',
                                title: `${response.message}`
                            })
                        }
                        // $('#myModal').modal('show');
                        // console.log($('#myModal'));
                        // console.log($('#myModal').modal());
                    });
                } else {
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                    });
                }
            }
        },
        changebalue(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            num = e.num * 1;
            this.child_number = num;
            if (e.sub.length !== 0) {
                this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                    if (response.result) {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num * this.child_number || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            this.free_parm = this.free.map(item => {
                                return {
                                    item: item.isubid,
                                    num: this.free_num * num
                                };
                            });
                            if (response.data.sub.length === 1) {
                                this.child_num = response.data.num || 0;
                                this.child_list[0].display_num = response.data.num

                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                this.opmodef(true);
                            } else if (response.data.num !== 0) {
                                const myModal = new this.$bootstrap.Modal(document.getElementById('h' + this.selectname), {
                                    keyboard: false
                                });
                                myModal.show();
                                let backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.style.display = 'none';
                                }

                            } else if (response.data.sub.length === 0) {
                                this.opmodef(true);
                            }
                        }
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })

                        Toast.fire({
                            icon: 'error',
                            title: `${response.message}`
                        })
                    }
                })
            } else {
                this.$store.dispatch("cart/update", {
                    itemid: e.item_id,
                    number: num,
                });
            }
        },
        // 删除商品
        del(e) {
            // console.log(this.selectname,e);
            if (e.sub.length !== 0) {
                this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                    if (response.result) {
                        // if (response.data.num !== 0) {
                        this.child_list = response.data.sub || [];
                        this.child_num = response.data.num || 0;
                        this.free = response.data.sub_free || [];
                        this.free_num = response.data.num_free || 0;
                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: 0
                            };
                        });
                        this.free_parm = this.free.map(item => {
                            return {
                                item: item.isubid,
                                num: 0
                            };
                        });
                        this.parm = this.parm.concat(this.free_parm);
                        this.free_parm = [];
                        this.$store.dispatch('cart/add', {
                            action: 'UPDATE',
                            itemid: e.item_id,
                            number: 0,
                            type: 'NOR',
                            param: this.parm,
                        }).then((e) => {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })
                            if (e.result) {
                                Toast.fire({
                                    icon: 'success',
                                    title: '成功删除'
                                })
                            } else {
                                Toast.fire({
                                    icon: 'error',
                                    title: `${e.message}`
                                })
                            }

                        });
                        // }
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })

                        Toast.fire({
                            icon: 'error',
                            title: `${response.message}`
                        })
                    }
                    // $('#myModal').modal('show');
                    // console.log($('#myModal'));
                    // console.log($('#myModal').modal());
                });
            } else {
                this.$store.dispatch("cart/del", {
                    itemid: e.item_id,
                }).then(() => {
                });
            }
        },
        //相关说明
        goshopping_instructions(e) {
            if (`/shopping_instructions` == this.$route.path) {
                //如果当前已经在这个页面不跳转 直接去 
                let toElement = document.getElementById(e);
                toElement.scrollIntoView(true);
            } else {
                //否则跳转路由 
                localStorage.setItem("toId", e);
                this.$router.push({ path: `/shopping_instructions` });
            }

        },
        increment(index) {
            console.log(123);
            console.log(this.totalSum, this.child_num);
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
        increment_free(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput_free(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement_free(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },


    },

    created() {
    },
    mounted() {
        // console.log('头部');
        // this.$store.dispatch("header/get").catch(e => {
        // });
        // this.$store.dispatch("header/getfb").then(() => {
        //     var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
        //     myFacebookEventApi.callPageView();
        // });
        // this.$store.dispatch('cart/get').then(() => {
        // });
        //监听滚动条
        let currentVal = 0;
        let scrollVal = 0;
        $(window).scroll(function () {
            currentVal = scrollVal;
            scrollVal = $(window).scrollTop();

            if (scrollVal <= 0) {
                return; // 如果滚动位置为负数，不执行任何操作
            }


            if (scrollVal > 350) {
                $("#category-list").css({ 'top': $('#navbar-collapse').outerHeight() + 'px' });
            } else {
                $("#category-list").removeAttr("style");
            }


            if (currentVal < scrollVal) {
                //滚动条下滑，实现下滑效果
                $('#mobile-menu').addClass('active');
                $('#mobile-icon').addClass('active');
                $('#navbar-collapse').removeClass('show');
                $("#category-list").removeAttr("style");
            } else {
                if (scrollVal > 350) {
                    $('#navbar-collapse').addClass('show');


                } else {
                    $('#navbar-collapse').removeClass('show');

                }

                $('#mobile-menu').removeClass('active');
                $('#mobile-icon').removeClass('active');
                //滚动条上滑，实现上滑效果
            }
        })
    },
}
</script>

<style lang='scss' scoped src="./index.scss"></style>

<style lang="scss" scoped>
::v-deep {
    .modal-backdrop {
        display: none;
    }

}

.child {

    h2 {
        margin: 0 0 16px;
    }

    .form_name {
        color: black;
        font-size: 16px;
    }

    .number {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        height: 40px;

        input {
            width: 100%;
            height: 40px;
            text-align: center;
            // max-height: 36px;
            outline-style: none;
            border: 1px solid #e2e2e2;
            border-left: none;
            border-right: none;

            &:focus {}
        }

        button {
            background-color: #fff;
            color: #BBB19E;
            height: 40px;
            line-height: 1.5px;
            padding: 6px 12px;
            border: 1px solid #e2e2e2;
            border-radius: 5px;
            cursor: pointer;

            &:not(:first-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 30px;
                // line-height: 1;
            }

            &:first-child {
                font-size: 38px;

                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* 针对 Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }

        /* 针对 IE11 */
        input[type=number]::-ms-clear {
            display: none;
        }

    }

    .btn {
        text-align: center;

        button {
            height: 40px;
            width: 100px;
            /* 重置边框和背景样式 */
            border: none;
            background: none;
            /* 重置内外边距 */
            padding: 0;
            margin: 0;
            /* 设置字体样式 */
            font-family: inherit;
            font-size: inherit;
            /* 设置颜色 */
            color: inherit;
            /* 设置鼠标样式 */
            cursor: pointer;
            /* 去除按钮的外观 */
            appearance: none;
            /* 其他可能需要的样式 */
            /* outline: none; */
            /* 注意：如果使用 outline: none;，请提供其他焦点样式以保持可访问性 */
            /* 其他重置样式，根据需要添加 */
            background-color: #11ADD8;
            color: white;
            border-radius: 5px;
        }
    }




}
</style>